import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import { RefreshCw } from "lucide-react";
import { Card, Empty } from "@/components/admin/ui";
import { api, errMsg, fmtDateTime } from "@/lib/api";

const TONE: Record<string, string> = {
  sent: "bg-[#DCFCE7] text-[#15803D]", retrying: "bg-[#FEF3C7] text-[#B45309]", sending: "bg-[#DBEAFE] text-[#1D4ED8]", failed: "bg-[#FEE2E2] text-[#B91C1C]",
};
const LABEL: Record<string, string> = { sent: "Sent", retrying: "Retrying", sending: "Sending", failed: "Failed" };

export function EmailOutbox() {
  const [data, setData] = useState<any>(null);
  const load = () => api.get("/admin/email-outbox").then((r) => setData(r.data)).catch((e) => toast.error(errMsg(e)));
  useEffect(() => { load(); const t = setInterval(load, 20000); return () => clearInterval(t); }, []);
  const act = (id: string, a: "retry" | "cancel") => api.post(`/admin/email-outbox/${id}/${a}`).then(() => { toast.success(a === "retry" ? "Will retry now" : "Cancelled"); load(); }).catch((e) => toast.error(errMsg(e)));
  return (
    <Card title="Email outbox" testId="email-outbox-card" actions={<button className="btn-secondary btn-sm" onClick={load} data-testid="email-outbox-refresh"><RefreshCw className="h-4 w-4" /> Refresh</button>}>
      <p className="px-6 pt-4 text-sm text-[#64748B]" data-testid="email-outbox-summary">
        When the email service is busy, emails wait here and send automatically (retried for up to 48 hours). {data ? `${data.retrying} waiting · ${data.failed} failed.` : ""}
      </p>
      {!data ? <div className="m-6 h-24 animate-pulse rounded-xl bg-slate-50" /> : !data.items.length ? <Empty text="No delayed emails. Everything has gone out on the first try." /> : (
        <ul className="divide-y divide-slate-100" data-testid="email-outbox-list">
          {data.items.map((d: any) => (
            <li key={d.id} className="flex flex-wrap items-center gap-3 px-6 py-3 text-sm" data-testid={`email-outbox-row-${d.id}`}>
              <span className={`rounded-full px-2.5 py-0.5 text-xs font-bold ${TONE[d.status]}`} data-testid={`email-outbox-status-${d.id}`}>{LABEL[d.status]}</span>
              <div className="min-w-0 flex-1 basis-[calc(100%-5rem)] sm:basis-auto">
                <p className="truncate font-semibold text-[#1A2536]">{d.subject}</p>
                <p className="truncate text-xs text-[#64748B]">To {d.to.join(", ")}{d.sent_by ? ` · from ${d.sent_by}` : ""} · {d.status === "sent" ? `sent ${fmtDateTime(d.sent_at)} after ${d.attempts} tries` : `queued ${fmtDateTime(d.created_at)} · ${d.attempts} tries · ${d.last_error || ""}`}</p>
              </div>
              {["failed", "retrying"].includes(d.status) && <div className="flex w-full gap-2 sm:w-auto">
                <button className="btn-secondary btn-sm" onClick={() => act(d.id, "retry")} data-testid={`email-outbox-retry-${d.id}`}>Retry now</button>
                <button className="btn-secondary btn-sm" onClick={() => act(d.id, "cancel")} data-testid={`email-outbox-cancel-${d.id}`}>Cancel</button>
              </div>}
            </li>
          ))}
        </ul>
      )}
    </Card>
  );
}
